import React, { ReactElement } from 'react'
import { stripEmptyFromArray } from '../../../helpers/dataTransformer'
import { IColorTheme } from '../../../types/itemTypes'
import { ICategoryResponse } from '../../../types/organisation'
import ItemGridSelect from './ItemGridSelect'

interface ICategorySelectProps {
  categories: ICategoryResponse[]
  selectedCategoryId: number | undefined
  setSelectedCategoryId: (categoryId?: number) => void
  setSelectedSubCategoryId: (categoryId?: number) => void
  colorTheme?: Partial<IColorTheme>
}
export default function CategorySelect(
  props: ICategorySelectProps,
): ReactElement {
  const {
    categories,
    selectedCategoryId,
    setSelectedCategoryId,
    setSelectedSubCategoryId,
    colorTheme,
  } = props

  const categoryOptions = stripEmptyFromArray(
    categories
      .sort((a, b) => a.order - b.order)
      .map((category) => {
        if (category.parent === 0) {
          return { value: category.id, label: category.title }
        }
        return null
      }),
  )

  const selectedCategory = categories.filter(
    (category) => category.id === selectedCategoryId,
  )[0]

  const selectedCategoryOption = selectedCategoryId
    ? {
      value: selectedCategoryId,
      label: selectedCategory.title,
    }
    : undefined

  return (
    <ItemGridSelect<number>
      placeholder="All categories"
      selected={selectedCategoryOption}
      options={categoryOptions}
      onSelect={(option): void => {
        if (option) {
          setSelectedCategoryId(option.value)
          setSelectedSubCategoryId(undefined)
        } else {
          setSelectedCategoryId()
        }
      }}
      colorTheme={colorTheme}
    />
  )
}
